import { useEffect, useState } from "react";
import { LayoutGrid } from "lucide-react";
import api from "../lib/api";
import Header from "../components/dashboard/Header";
import NotionBoard from "../components/NotionBoard";

export default function Boards() {
  const [boards, setBoards] = useState([]);
  const [configured, setConfigured] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [boardId, setBoardId] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/notion/boards");
        setConfigured(data.configured);
        setBoards(data.boards || []);
        if (data.boards?.length) setBoardId(data.boards[0].id);
      } catch (e) { setLoadError(e.userMessage); }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-brand-page flex flex-col">
      <Header />
      <main className="max-w-full mx-auto px-6 lg:px-12 py-8 flex-1 w-full">
        <div className="mb-6">
          <h1 className="font-serif text-4xl text-brand-ink tracking-tight" data-testid="boards-title">Boards</h1>
          <p className="text-sm text-brand-muted mt-1">Your Notion task boards — create, edit and drag between columns. Syncs live with Notion.</p>
        </div>

        {loadError ? (
          <div className="text-sm text-brand-neg" data-testid="boards-error">Notion boards couldn't load: {loadError} Refresh to retry.</div>
        ) : !configured ? (
          <div className="text-sm text-brand-muted" data-testid="boards-not-configured">No Notion token saved yet — boards are off.</div>
        ) : !boards.length ? (
          <div className="text-sm text-brand-muted" data-testid="boards-empty">No boards shared with the integration yet. In Notion, open a board → ••• → Connections → Bond Hub.</div>
        ) : (
          <>
            <div className="mb-5">
              <div className="relative inline-block">
                <LayoutGrid className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-brand-tertiary" />
                <select value={boardId} onChange={(e) => setBoardId(e.target.value)} data-testid="board-select"
                  className="pl-9 pr-8 py-2 text-sm border border-brand-border rounded-lg bg-brand-surface text-brand-ink min-w-[240px]">
                  {boards.map((b) => <option key={b.id} value={b.id}>{b.title}</option>)}
                </select>
              </div>
            </div>
            {boardId && <NotionBoard boardId={boardId} />}
          </>
        )}
      </main>
    </div>
  );
}
